/**
 * Test if an img src resource is loaded.
 * Note that `complete` can be true even when an error occurs (ie. 404). For this reason we also need to check for the `natural` dimensions. These are only present when the image resource exists.
 * @param imgElement {Element} The `img` element that we're checking to see if the src resource is loaded.
 * @returns {boolean}
 */
export function isImgLoaded(imgElement) {
    if (!imgElement) return;
    if (imgElement.complete) {
        // Checking the `naturalWidth` and `naturalHeight` properties is the *only* why to check if the img src has actually loaded.
        return !(!imgElement.naturalWidth || !imgElement.naturalHeight);
    } else {
        return false;
    }
}

/**
 * Encodes an SVG string to be safely used as a CSS background image URL.
 *
 * This function applies URI encoding to ensure all characters in the SVG string
 * are correctly represented in a URL context. It specifically handles special
 * characters like quotes to prevent syntax issues in CSS. The resulting string
 * is returned as a formatted data URI suitable for CSS background-image usage.
 *
 * @param {string} svgString - The raw SVG markup to be encoded.
 * @return {string} The encoded SVG string wrapped in a CSS URL function.
 */
export function svgForBackgroundImage(svgString) {
    // Encode the SVG string using encodeURIComponent
    const encodedSvg = encodeURIComponent(svgString)
        .replace(/'/g, "%27")  // Encode single quotes
        .replace(/"/g, "%22"); // Encode double quotes

    // Return the fully encoded SVG ready for use as a background image
    return `url('data:image/svg+xml,${encodedSvg}')`;
}
